<template lang="pug">
div
    Button(type="primary" @click="openModal()" icon="md-add") {{ $t('rcmtable.editText') }}
    Row(type="flex" justify="space-between")
        Col(:span="22")
            // Card
            Card(v-for="(cacheItem, index) in enabledValue" :key="index")
                // Card title
                template(slot="title")
                    Row(type="flex" justify="space-between")
                        Col
                            h4 {{ `${$t(`domainsetting.${cacheItem.cacheType}`)}` }} {{ cacheItem.uriPath }}
                        Col
                            span(style="color: rgba(0, 0, 0, 0.45);") {{ cacheItem.description }}
                // Card body
                Row(type="flex" justify="space-between")
                    Col(span="11")
                        // 例外
                        //- Row(v-if="cacheItem.exCacheArgsRules.length > 0" style="padding-bottom: 16px")
                            Col(span="24")
                                List
                                    ListItem(style="border: none; padding: 0 0 4px;")
                                        ListItemMeta(
                                            :title="$t('domainsetting.exception')"
                                            :description="cardExceptionDescription(cacheItem.cacheType)"
                                        )
                                    ListItem(v-for="(noCacheArgsRuleItem, argsIndex) in cacheItem.exCacheArgsRules" :key="argsIndex"  style="border: none; padding: 0 0 4px;")
                                        ListItemMeta(
                                            :description="cardExCacheArgsRulesDescription(argsIndex, cacheItem.cacheType ,noCacheArgsRuleItem)"
                                            v-show="noCacheArgsRuleItem.key!=''"
                                        )
                        // Args 緩存策略
                        Row(v-show="isShowCacheFields(cacheItem)")
                            Col(span="24")
                                List
                                    ListItem(style="border: none; padding: 0 0 4px;")
                                        ListItemMeta(
                                            :title="$t('domainsetting.argsType')"
                                            :description="cardArgsTypeDescription(cacheItem)"
                                        )
                                    ListItem(v-for="(argsRuleItem, argsIndex) in cacheItem.argsRules" :key="argsIndex" style="border: none; padding: 0 0 4px;")
                                        ListItemMeta(
                                            :description="cardArgsRulesDescription(argsIndex, cacheItem.argsType, argsRuleItem)"
                                            v-show="argsRuleItem.key!=''"
                                        )
                    // 表頭、分片與時間
                    Col(span="8" style="color: rgba(0, 0, 0, 0.45);")
                        Row(v-show="cacheItem.isPassSetCookie && isShowSetCookieAndSlice(cacheItem)" type="flex" align="middle")
                            Icon(type="md-download" style="padding: 5px;")
                            span Set-Cookie
                        Row(v-show="cacheItem.isSlice && isShowSetCookieAndSlice(cacheItem)" type="flex" align="middle")
                            Icon(type="logo-buffer" style="padding: 5px;")
                            span {{ cacheItem.slice }} MB
                        Row(v-show="isShowExpirationFields(cacheItem)"  type="flex" align="middle")
                            Icon(type="md-timer" style="padding: 5px;")
                            span {{ $t('domainsetting.browser' )}} {{ cacheItem.browserExp }} {{ $t('global.min') }}
                        Row(v-show="isShowExpirationFields(cacheItem)"  type="flex" align="middle")
                            Icon(type="md-timer" style="padding: 5px;")
                            span {{ $t('domainsetting.server') }} {{ cacheItem.serverExp }} {{ $t('global.min') }}
                        Row(v-show="cacheItem.proxyCacheLock && isShowSetCookieAndSlice(cacheItem)" type="flex" align="middle")
                            Icon(type="md-lock" style="padding: 5px;")
                            span {{ $t('domainsetting.proxyCacheLock') }}
        // Modal
        Modal(v-model="isShowModal" :title="$t('domainsetting.cacheUrlRules')" width="1000" :footer-hide="true")
            // 增加規則
            Row(type="flex" justify="end")
                Button(type="primary" @click="addCacheRule" icon="md-add") {{ $t('domainsetting.addRewriteRule') }}
            // 每一條規則
            draggable(tag="ul" :list="cacheRules" handle=".cacheRulesHandle")
                Row(v-for="(cacheRule, ruleIndex) in cacheRules" :key="ruleIndex")
                    Form(style="width: 100%;" label-position="left")
                        // 路徑與規則
                        Row(style="margin: 16px 0; height: 32px;" justify="space-between" align="middle")
                            Col
                                div(style="display: flex; align-items: center;")
                                    Icon(type="md-reorder" class="fa fa-align-justify cacheRulesHandle" style="cursor: move; width: 32px;")
                                    h3 {{ $t('domainsetting.uriPathAndCacheRule') }}
                            Col
                                Button(type="error" icon="md-close" @click="removeCacheRule(ruleIndex)" v-show="cacheRules.length !== 1" ghost) {{ $t('domainsetting.removeRewriteRule') }}
                        Row
                            Col(flex="52px")
                            Col(flex="auto")
                                Row(:gutter="16")
                                    Col(span="6")
                                        FormItem(:label-width="40" :label="$t('domainsetting.uriPath')")
                                            Input(v-model="cacheRule.uriPath")
                                    Col(span="6")
                                        FormItem(:label-width="80" :label="$t('domainsetting.cacheType')")
                                            Select(v-model="cacheRule.cacheType")
                                                Option(v-for="item in cacheOptions" :value="item.value" :key="item.value") {{ item.label }}
                                    Col(span="6")
                                        FormItem(:label-width="40" :label="$t('domainsetting.note')")
                                            Input(v-model="cacheRule.description")
                        // 例外
                        //- Row(style="margin-bottom: 16px;")
                            div(style="width: 32px;")
                            h3 {{ $t("domainsetting.exception") }}
                        //- Row
                            Col(flex="52px")
                            Col(flex="auto")
                                Row(justify="space-between")
                                    Col
                                        FormItem(:label="cardExceptionDescription(cacheRule.cacheType)")
                                    Col
                                        Button(@click="addCacheArgsRule(ruleIndex,'exCacheArgsRules')" icon="md-add") {{ $t('domainsetting.addArgsRulesBtnPrefix') + oppositeCacheType(cacheRule.cacheType) + $t('domainsetting.addArgsRulesBtnSuffix') }}
                                draggable(tag="ul" :list="cacheRule.exCacheArgsRules" handle=".exCacheArgsRules")
                                    Row(v-for="(argsRule, index) in cacheRule.exCacheArgsRules" :key="index" :gutter="16")
                                        Col(span="1")
                                            Icon(type="md-reorder" class="fa fa-align-justify exCacheArgsRules" style="cursor: move; width: 32px; padding-top: 10px; box-sizing: border-box;")
                                        Col(span="5")
                                            FormItem(:label-width="40" :label="$t('domainsetting.argsKey')")
                                                Input(v-model="argsRule.key" size="small")
                                        Col(span="6")
                                            FormItem(:label-width="50" :label="$t('domainsetting.argsValue')")
                                                Input(v-model="argsRule.value" size="small")
                                        Col(span="6")
                                            FormItem(:label-width="40" :label="$t('domainsetting.note')")
                                                Input(v-model="argsRule.description" size="small")
                                        Col(style="padding-top: 10px;" span="1" offset="5")
                                            Button(type="error" ghost shape="circle" icon="md-trash" @click="removeCacheArgsRule(ruleIndex, index,'exCacheArgsRules')" size="small" )
                        // 表頭、分片與時間
                        Row(style="margin-bottom: 16px;" v-show="isShowSetCookieAndSlice(cacheRule)")
                            div(style="width: 32px;")
                            h3 {{ $t('domainsetting.headerSliceAndExpTime') }}
                        Row
                            Col(flex="52px")
                            Col(flex="auto")
                                Row(:gutter="16")
                                    Col(span="6" v-show="isShowSetCookieAndSlice(cacheRule)")
                                        FormItem
                                            Checkbox(v-model="cacheRule.isPassSetCookie")
                                            Poptip(width="500" v-if="cacheRule.cacheType !== 'notCache'" :content="$t(`domainsetting.isPassSetCookiePoptipContent.${cacheRule.cacheType}`)" placement="right" trigger="hover" word-wrap style="word-break: break-all;")
                                                div(style="display:flex; flex-direction: column;")
                                                    p {{ $t('domainsetting.isPassSetCookie') }}
                                                    ul(style="list-style-position: inside;")
                                                        li Set-Cookie
                                                        template(v-if="cacheRule.cacheType === 'cache'")
                                                            li Cache-Control
                                                            li Expires
                                    Col(span="6" v-show="isShowExpirationFields(cacheRule)")
                                        FormItem(:label-width="110" :label="$t('domainsetting.browserExp')")
                                            FormInputNumber(v-model="cacheRule.browserExp" :formItem="{needTransferUnit:true}")
                                    Col(span="6" v-show="isShowSetCookieAndSlice(cacheRule)")
                                        FormItem(:label="$t('domainsetting.proxyCacheLock')")
                                            Poptip(:content="$t('domainsetting.proxyCacheLockPoptipContent')" placement="right" trigger="hover" word-wrap style="word-break: break-all;")
                                                i-switch(v-model="cacheRule.proxyCacheLock")
                                Row(:gutter="16")
                                    Col(span="6" v-show="isShowSetCookieAndSlice(cacheRule)")
                                            FormItem
                                                Checkbox(v-model="cacheRule.isSlice")
                                                Poptip(:content="$t('domainsetting.slicePoptipContent')" placement="right" trigger="hover" word-wrap style="word-break: break-all;")
                                                    span {{ $t('domainsetting.slice') }}
                                                InputNumber(:disabled="!cacheRule.isSlice" v-model="cacheRule.slice" type="number" :min="5" :max="50" :step="1" style="margin: 0 8px; width: 42px;")
                                                span MB
                                    Col(span="6")
                                        FormItem(:label-width="110" :label="$t('domainsetting.serverExp')" v-show="isShowExpirationFields(cacheRule)")
                                            FormInputNumber(v-model="cacheRule.serverExp" :formItem="{needTransferUnit:true}")
                        // 如何處理請求 Args
                        Row(style="margin-bottom: 16px;" v-show="isShowCacheFields(cacheRule)")
                            div(style="width: 32px;")
                            h3 {{ $t("domainsetting.howToHandleRequestArgs") }}
                        Row
                            Col(flex="52px")
                            Col(flex="auto")
                                Row(justify="space-between" v-show="isShowCacheFields(cacheRule)")
                                    Col(span="12")
                                        FormItem(:label-width="140" :label="$t('domainsetting.argsType')")
                                            Select(v-model="cacheRule.argsType")
                                                Option(v-for="item in argsOptions" :value="item.value" :key="item.value") {{ item.label }}
                                    Col
                                        Button(@click="addCacheArgsRule(ruleIndex,'argsRules')"
                                        icon="md-add"
                                        v-show="cacheRule.argsType=='keepParams' || cacheRule.argsType=='ignoreParams'"
                                        :disabled="disabledByCache(ruleIndex)"
                                        ) {{ $t("domainsetting.addSpecificArgsRulesBtn") }}
                                draggable(tag="ul" :list="cacheRule.argsRules" handle=".cacheArgsRuleHandle")
                                    Row(v-for="(argsRule, index) in cacheRule.argsRules" :key="index" v-show="isShowArgs(cacheRule)" :gutter="16")
                                        Col(span="1")
                                            Icon(type="md-reorder" class="fa fa-align-justify cacheArgsRuleHandle" style="cursor: move; width: 32px; padding-top: 10px; box-sizing: border-box;")
                                        Col(span="5")
                                            FormItem(:label-width="40" :label="$t('domainsetting.argsKey')")
                                                Input(v-model="argsRule.key" size="small" :disabled="disabledByCache(ruleIndex)")
                                        Col(span="6")
                                            FormItem(:label-width="50" :label="$t('domainsetting.argsValue')")
                                                Input(v-model="argsRule.value" size="small" :disabled="disabledByCache(ruleIndex)")
                                        Col(span="6")
                                            FormItem(:label-width="40" :label="$t('domainsetting.note')")
                                                Input(v-model="argsRule.description" size="small" :disabled="disabledByCache(ruleIndex)")
                                        Col(style="padding-top: 10px;" span="1" offset="5")
                                            Button(type="error" ghost shape="circle" icon="md-trash" @click="removeCacheArgsRule(ruleIndex, index,'argsRules')" size="small")
                        Divider
            Row(type="flex" justify="end" style="margin-top: 5px;")
                Button(type="default" @click="cancel" style="margin-right: 10px;") {{ $t('rcmtable.cancelText') }}
                Button(type="default" @click="clear" style="margin-right: 10px;" :disabled="disabled") {{ $t('rcmtable.clear') }}
                Button(type="default" @click="ok" ) {{ 'OK' }}
</template>
<script>
import draggable from "vuedraggable";
import FormInputNumber from "../rcmTableFormItems/InputNumber";
export default {
    name: "CacheURLModal",
    props: ["formItem", "formData", "value"],
    components: {
        draggable,
        FormInputNumber,
    },
    data() {
        return {
            isShowModal: false,
            cacheRules: JSON.parse(JSON.stringify(this.value)),
            limitArgsRules: 5,
            limitArgsNoCacheRules: 5,
            cacheOptions: [
                {
                    value: "followOrigin",
                    label: this.$t("domainsetting.followOrigin"),
                },
                {
                    value: "cache",
                    label: this.$t("domainsetting.cache"),
                },
                {
                    value: "notCache",
                    label: this.$t("domainsetting.notCache"),
                },
            ],
            argsOptions: [
                {
                    value: "keepAll",
                    label: this.$t("domainsetting.keepAll"),
                },
                {
                    value: "ignoreAll",
                    label: this.$t("domainsetting.ignoreAll"),
                },
                {
                    value: "keepParams",
                    label: this.$t("domainsetting.keepParams"),
                },
                {
                    value: "ignoreParams",
                    label: this.$t("domainsetting.ignoreParams"),
                },
            ],
        };
    },
    methods: {
        openModal() {
            this.isShowModal = true;
            this.cacheRules = JSON.parse(JSON.stringify(this.value));
            if (this.cacheRules.length == 0) {
                this.addCacheRule();
            }
        },
        addCacheRule() {
            if (this.cacheRules.length >= this.limitRules) {
                return this.$Message.error(`The maximum is ${this.limitRules} Rules.`);
            }
            this.cacheRules.push({
                cacheType: "cache",
                uriPath: "", //請求路徑
                description: `rule ${1 + this.cacheRules.length}`, // 敘述
                isSlice: false,
                slice: 5,
                isPassSetCookie: false,
                browserExp: 5, //瀏覽器過期時間
                serverExp: 5, //節點過期時間
                proxyCacheLock: false,
                argsType: "keepAll",
                argsRules: [
                    // {
                    //     key: "", // key
                    //     value: "", // value
                    //     description: "", // 敘述
                    // },
                ],
                exCacheArgsRules: [
                    // {
                    //     key: "", // key
                    //     value: "", // value
                    //     description: "", // 敘述
                    // },
                ],
            });
        },
        removeCacheRule(index) {
            this.cacheRules.splice(index, 1);
        },
        addCacheArgsRule(index, name) {
            if (name == "argsRules") {
                if (this.cacheRules[index][name].length >= this.limitArgsRules) {
                    return this.$Message.error(`The maximum is ${this.limitArgsRules} Args Rules.`);
                }
            }
            if (name == "exCacheArgsRules") {
                if (this.cacheRules[index][name].length >= this.limitArgsNoCacheRules) {
                    return this.$Message.error(`The maximum is ${this.limitArgsNoCacheRules} Args noCache Rules.`);
                }
            }
            this.cacheRules[index][name].push({
                description: "", // 敘述
                key: "", // key
                value: "", // value
            });
        },
        removeCacheArgsRule(ruleIndex, argsIndex, name) {
            this.cacheRules[ruleIndex][name].splice(argsIndex, 1);
        },
        cancel() {
            this.isShowModal = false;
            this.$emit("input", this.value);
        },
        clear() {
            if (this.cacheRules.length > 0) {
                this.$Modal.confirm({
                    title: "Clear",
                    content: "Are you sure you want to clear all data？",
                    onOk: () => {
                        this.isShowModal = false;
                        this.cacheRules = [];
                        this.$emit("input", []);
                    },
                });
            } else {
                this.isShowModal = false;
                this.cacheRules = [];
                this.$emit("input", []);
            }
        },
        ok() {
            const emptyPathRule = this.cacheRules.find((e) => e.uriPath == "");
            if (emptyPathRule) {
                return this.$Message.error(`empty path found.`);
            }
            const emptyArgsRules = this.cacheRules.find(
                (e) => e.argsRules.length == 0 && (e.argsType === "keepParams" || e.argsType === "ignoreParams")
            );
            if (emptyArgsRules) {
                return this.$Message.error(`empty args rule.`);
            }

            // 驗證路徑是否有無重複
            const repeatData = this.cacheRules.reduce((obj, item) => {
                if (!obj[item.uriPath]) {
                    obj[item.uriPath] = item;
                }
                return obj;
            }, {});
            const valRepeatData = Object.values(repeatData);
            if (valRepeatData.length != this.cacheRules.length) {
                return this.$Message.error(`The path must be unique.`);
            }

            // 驗證 argsRules,exCacheArgsRules 資料型態key是否為空值
            const findEmptyKey = this.cacheRules.find(
                (rule) =>
                    ((rule.argsType === "keepParams" || rule.argsType === "ignoreParams") &&
                        rule.argsRules.find((ruleItem) => ruleItem.key == "")) ||
                    rule.exCacheArgsRules.find((ruleItem) => ruleItem.key == "")
            );
            if (findEmptyKey) {
                return this.$Message.error(`Rules has key empty.`);
            }

            // 驗證 argsRules,exCacheArgsRules 資料key&value是否有正則符號
            const regexSymbols = /[.*+?^${}()|[\]\\]/;
            const findRegexSymbols = this.cacheRules.find(
                (rule) =>
                    ((rule.argsType === "keepParams" || rule.argsType === "ignoreParams") &&
                        rule.argsRules.find(
                            (ruleItem) => regexSymbols.test(ruleItem.key) || regexSymbols.test(ruleItem.value)
                        )) ||
                    rule.exCacheArgsRules.find(
                        (ruleItem) => regexSymbols.test(ruleItem.key) || regexSymbols.test(ruleItem.value)
                    )
            );
            if (findRegexSymbols) {
                return this.$Message.error(`Regular expressions were found in the key-value pairs within the rules.`);
            }

            // 不忽略||ignoreAll不用依據args做判斷，所以全部移除
            this.cacheRules = this.cacheRules.map((rule) => {
                if (rule.argsType === "keepAll" || rule.argsType === "ignoreAll") {
                    rule.argsRules = [];
                }
                if (rule.cacheType == "notCache" && rule.exCacheArgsRules.length == 0) {
                    rule.argsType = "keepAll";
                    rule.argsRules = [];
                }
                return rule;
            });

            this.$emit(
                "input",
                this.cacheRules.map((item) => {
                    item.slice = parseInt(item.slice);
                    item.browserExp = parseInt(item.browserExp);
                    item.serverExp = parseInt(item.serverExp);
                    return item;
                })
            );
            this.isShowModal = false;
        },
        oppositeCacheType(val) {
            const isCache = val != "notCache";
            return isCache ? this.$t("domainsetting.notCache") : this.$t("domainsetting.cache");
        },
        disabledByCache(index) {
            const cacheRule = this.cacheRules[index];
            return cacheRule.cacheType == "notCache" && !cacheRule.exCacheArgsRules.some((rule) => rule.key !== "");
        },
        isShowCacheFields(item) {
            return item.cacheType != "notCache" || (item.cacheType == "notCache" && item.exCacheArgsRules.length > 0);
        },
        isShowExpirationFields(item) {
            return item.cacheType == "cache" || (item.cacheType == "notCache" && item.exCacheArgsRules.length > 0);
        },
        isShowArgs(item) {
            // 不是不緩存||是緩存但有例外者
            if (item.cacheType != "notCache" || (item.cacheType == "notCache" && item.exCacheArgsRules.length > 0)) {
                // Args類型是 保留指定||忽略指定
                if (item.argsType == "keepParams" || item.argsType == "ignoreParams") {
                    return true;
                }
            }
        },
        isShowSetCookieAndSlice(item) {
            return item.cacheType == "cache" || item.cacheType == "followOrigin";
        },
        cardExceptionDescription (type){
            return this.$t('domainsetting.hitCacheUrlRule') + this.oppositeCacheType(type) + this.$t('domainsetting.exCacheArgsRules');
        },
        cardExCacheArgsRulesDescription(index, type ,item){
            return `${index + 1}. ${this.oppositeCacheType(type)} ${item.key}=${item.value}`;
        },
        cardArgsTypeDescription(item) {
            return this.$t(`domainsetting.${item.argsType}`).split(/[：:]/g)[0];
        },
        cardArgsRulesDescription(index, type, item) {
            let typeIsKeepOrIgnore = `${
                type.includes("keep") ? this.$t(`domainsetting.isTrueForward`) : this.$t(`domainsetting.isFalseForward`)
            }`;
            return `${index + 1}. ${typeIsKeepOrIgnore} ${item.key}=${item.value}`;
        },
    },
    created() {},
    computed: {
        disabled() {
            return typeof this.formItem.disabled == "function" ? this.formItem.disabled() : this.formItem.disabled;
        },
        enabledValue() {
            return this.value.filter((rewriteItem) => rewriteItem.uriPath !== "");
        },
        limitRules() {
            const defaultValue = 5;
            if (!this.formData.groupName) return defaultValue;
            const groupConfig =
                this.$store.state.platformPlan.multiTenancyConfigs.maxRuleCountOfCacheRules &&
                this.$store.state.platformPlan.multiTenancyConfigs.maxRuleCountOfCacheRules.find(
                    (group) => group.groupName == this.formData.groupName
                );
            return groupConfig ? groupConfig.maxRuleCountOfCacheRules : defaultValue;
        },
    },
};
</script>
<style scope>
.ivu-form-item {
    margin-bottom: 16px;
}
</style>



// WEBPACK FOOTER //
// src/components/FormItems/CacheURLModal.vue